import React from 'react'
import { Link } from 'react-router-dom'
import moment from 'moment'

import { getDatetime } from '../../utils/js/time_helpers'
import { preserveQueryParams } from 'utils/js/browser_helpers'

export const getPlayerNameWithFlag = (name = '', image = null, rank = '', playoff = false) => {
    name = name && name.trim()
    const addDefaultSrc = ev => {
        ev.target.src =
            'data:image/gif;base64,R0lGODlhAQABAIAAAP///wAAACH5BAEAAAAALAAAAAABAAEAAAICRAEAOw=='
    }
    if (!name) return <span>-</span>
    return (
        <span
            className={`AncillaryLeague_nameflag_cell ${
                rank === '1' && playoff === true ? 'playoff_winner' : ''
            }`}
        >
            {image && (
                <img onError={addDefaultSrc} src={image} title="Player Country" alt="Player Flag" />
            )}
            {rank === '1' && playoff === true && <span className="player_playoff">x -</span>} {name}
        </span>
    )
}

export const getEventCellOutput = (
    id = '',
    name = '',
    course = null,
    location = null,
    sport = '',
    league = '',
    status = ''
) => {
    const location_str = [location, course].filter(a => a).join(' ')
    if (sport === 'auto-racing') {
        return (
            <div className="AncillaryLeague_event_cell">
                <div>
                    {name} -{' '}
                    {sport === 'auto-racing' && status.toLowerCase().includes('in-progress') ? (
                        <Link to={preserveQueryParams(`/${sport}/${league}/events/${id}`)}>
                            View Race
                        </Link>
                    ) : (
                        <Link to={preserveQueryParams(`/${sport}/${league}/events/${id}`)}>
                            {' '}
                            Starting Grid
                        </Link>
                    )}
                </div>
            </div>
        )
    } else {
        return (
            <div className="AncillaryLeague_event_cell">
                <Link to={preserveQueryParams(`/${sport}/${league}/events/${id}`)}>{name}</Link>
                {location_str.length > 2 ? <div className="details">{location_str}</div> : ''}
            </div>
        )
    }
}

export const getResultCellOutput = (id = '', name = '', sport = '', league = '') => {
    return (
        <div className="AncillaryLeague_event_cell">
            <div>
                {name} -{' '}
                <Link to={preserveQueryParams(`/${sport}/${league}/events/${id}`)}>
                    Full Results
                </Link>
            </div>
        </div>
    )
}

export const getTimeStructure = (date = '', local_time = '') => (
    <div>
        <div>
            {date} {' - '} {local_time}
        </div>
    </div>
)

export const slugMap = league => {
    if (league === 'formula-1') {
        return 'form1'
    } else if (league === 'nascar-xfinity') {
        return 'nascar_2'
    } else if (league === 'ntt-indy-car') {
        return 'indycar'
    } else if (league === 'nascar-cup') {
        return 'nascar'
    } else {
        return league
    }
}

export const autoEventTime = timestamp => {
    let local_time = moment
        .unix(timestamp)
        .local()
        .format('h:mm A')

    let day = moment
        .unix(timestamp)
        .local()
        .format('ddd')

    let date = `${getDatetime(timestamp, 'month.day')}`
    local_time = `${local_time}`
    return { day, date, local_time }
}

export const formatSurface = surface => {
    switch (surface) {
        case 'hardcourt_indoor':
        case 'hardcourt_outdoor':
            return 'Hard'
        case 'red_clay':
            return 'Red Clay'
        case 'grass':
            return 'Grass'
        default:
            return surface
    }
}
